// import axios from "../../service/index";
let corpid = 'ww05f5d2c3824d6d4e'
// let agentid = '1000025'
export const getParams = (search) => {
  var params = {};
  if (search.indexOf("?") === 0 && search.indexOf("=") > 1) {
      var paramArray = unescape(search).substring(1, search.length).split("&");
      if (paramArray.length > 0) {
          paramArray.forEach(function (currentValue) {
              params[currentValue.split("=")[0]] = currentValue.split("=")[1];
          });
      }
  }
  return params;
}
export const globalConfig = (dataObj, jsApiList) => {
        window.wx.config({
            timestamp: dataObj.timestamp, // 必填，生成签名的时间戳
            nonceStr: dataObj.noncestr,
            beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
            debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: corpid, // 必填，企业微信的corpID
            signature: dataObj.signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
            jsApiList: jsApiList||[] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
        })
}
export const throttle = (fn, wait) => {
    let canrun = true
    return function() {
        if(!canrun) return;
        canrun = false
        setTimeout(() => {
            fn.apply(this, arguments)
        }, wait)
    }
}